const AdminUserState = () =>
  import("@/admin/user-state/views/AdminUserState.vue");
const AdminUserStateDetail = () =>
  import("@/admin/user-state/views/UserStateDetail.vue");
const UserStateViewManagement = () =>
  import("@/admin/user-state/views/UserStateViewManagement.vue");

const UserStateViewDetail = () =>
  import("@/admin/user-state/views/UserStateViewDetail.vue");

export const userStateRoutes = [
  {
    path: "/admin/user-state",
    name: "AdminUserState",
    component: AdminUserState,
  },
  {
    path: "/admin/user-state/:id",
    name: "AdminUserStateDetail",
    component: AdminUserStateDetail,
    props: true,
  },
  {
    path: "/admin/user-state-views/edit/:id?",
    name: "UserStateViewDetail",
    component: UserStateViewDetail,
    props: true,
  },
  {
    path: "/admin/user-state-views",
    name: "UserStateViewManagement",
    component: UserStateViewManagement,
  },
];
